import React, { useEffect } from 'react';
import { ChartersPage } from '../assets/ChartersComponents/ChartersPage';
import Logo from '../assets/Logo/mainlogo.png';

export const Charters = () => {
    useEffect(() => {
        // Set the id of the body element when the component mounts
        document.body.id = 'Chartersbody';
        // Remove the id when the component unmounts
        return () => {
            document.body.id = '';
        };
    }, []);

    return (
        <div>
             <nav className="navbar-revamp">


                <ul className="nav-links-revamp">
                    <li><a href="/" style={{color:"black"}}>Home</a></li>
                    <li><a href="/Gallery" style={{color:"black"}}>Gallery</a></li>
                    <li><a href="/Charters" style={{color:"black"}}>Charters</a></li>
                </ul>
                <div className="logo-container-revamp">
                    <img
                        src={Logo}
                        alt="EPIC Texas Charters Logo"
                        className="logo-revamp"
                    />
                </div>

                <div className="nav-button-revamp">
                    <button style={{color:"black"}}>Contact Us</button>
                </div>
            </nav>
            <ChartersPage />
        </div>
    );
};

export default Charters;
